module.exports = __webpack_public_path__ + "img/Circulo-Logo-TesteoMaterial-selected.6587f508.png";